import api from "app/api";
import { Options } from "common";

export interface Booking {
  id: number;
  booking_number?: string;
  // Add other booking fields as needed
}

export interface PaymentTransaction {
  id: number;
  token: string;
  booking_id: number;
  booking: Booking;
  status: "created" | "pending" | "paid" | "failed" | "expired" | "cancelled";
  gateway: string | null;
  amount: number | null;
  currency: string | null;
  billing_data: {
    first_name?: string;
    last_name?: string;
    country?: string;
    postcode?: string;
    city?: string;
    street_address?: string;
    phone?: string;
    email?: string;
    is_company?: boolean;
    company_name?: string;
    vat_number?: string;
    apartment?: string;
    county?: string;
  } | null;
  stripe_checkout_session_id: string | null;
  stripe_payment_intent_id: string | null;
  expires_at: string | null;
  paid_at: string | null;
  failure_reason: string | null;
  metadata: Record<string, any> | null;
  invoiced: boolean;
  created_by: number;
  updated_by: number;
  created_at: string;
  updated_at: string;
}

export type PaymentTransactionOptions = Options<"status">;

export function getPaymentTransactionService(scope?: any) {
  return api.getService<
    PaymentTransaction,
    PaymentTransaction,
    PaymentTransactionOptions
  >("payment-transactions", {
    scope,
    //params goes here
  });
}
